import { filterReducer } from './filterReducer';
import { displayPreferenceReducer } from './displayPreferenceReducer';
import { measurementUnitReducer } from './measurementUnitReducer';

export const sbSharedReducers = {
    filters: filterReducer,
    displayPreferences: displayPreferenceReducer,
    measurementUnit: measurementUnitReducer,
};
